var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExportSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 168,
    viewBox: "0 0 168 168",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4571_228317",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 168,
    height: 168
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M168 0H0V168H168V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4571_228317)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.254545
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.5523 44.1442C92.5523 45.6192 91.3565 46.815 89.8816 46.815C88.4066 46.815 87.2109 45.6192 87.2109 44.1442C87.2109 42.6693 88.4066 41.4736 89.8816 41.4736C91.3565 41.4736 92.5523 42.6693 92.5523 44.1442Z",
    fill: "#32D16D"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.590947
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.5303 50.445L69.9442 51.3607C69.6571 51.5265 69.2899 51.428 69.1241 51.141L66.2602 46.1805C66.0944 45.8934 66.1929 45.5263 66.4799 45.3605L68.0661 44.4448C68.3531 44.279 68.7203 44.3774 68.8861 44.6645L71.75 49.6249C71.9158 49.9121 71.8174 50.2792 71.5303 50.445Z",
    fill: "#32D16D"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.590947
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.7933 61.2224L45.15 61.3434C45.5545 61.4806 46.0007 61.4099 46.3431 61.1544L46.645 60.9291C47.5072 60.2857 48.733 60.9102 48.7192 61.9859L48.7144 62.3626C48.7089 62.7898 48.9139 63.1923 49.2627 63.439L49.5703 63.6565C50.4487 64.2777 50.2334 65.6363 49.2062 65.9556L48.8464 66.0675C48.4384 66.1943 48.1191 66.5137 47.9924 66.9216L47.8804 67.2814C47.5612 68.3087 46.2025 68.5239 45.5813 67.6455L45.3637 67.338C45.117 66.9892 44.7145 66.7841 44.2874 66.7896L43.9107 66.7943C42.835 66.8081 42.2105 65.5825 42.8539 64.7202L43.0793 64.4183C43.3348 64.076 43.4054 63.6298 43.2682 63.2252L43.1472 62.8685C42.8018 61.8496 43.7744 60.877 44.7933 61.2224Z",
    fill: "#FFC66D"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.590947
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.2597 80.1381L42.6603 81.9252C42.7328 82.2487 42.5294 82.5698 42.2058 82.6422L36.6167 83.8951C36.2933 83.9676 35.9722 83.7642 35.8996 83.4407L35.499 81.6535C35.4266 81.33 35.63 81.009 35.9535 80.9365L41.5426 79.6836C41.8661 79.6111 42.1872 79.8146 42.2597 80.1381Z",
    fill: "#32D16D"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.590947
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.9349 103.002C47.9349 104.477 46.7392 105.672 45.2643 105.672C43.7893 105.672 42.5938 104.477 42.5938 103.002C42.5938 101.527 43.7893 100.331 45.2643 100.331C46.7392 100.331 47.9349 101.527 47.9349 103.002Z",
    fill: "#32D16D"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.590947
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.7933 116.152L45.15 116.273C45.5545 116.41 46.0007 116.34 46.3431 116.084L46.645 115.859C47.5072 115.215 48.733 115.84 48.7192 116.916L48.7144 117.292C48.7089 117.72 48.9139 118.122 49.2627 118.369L49.5703 118.586C50.4487 119.207 50.2334 120.566 49.2062 120.885L48.8464 120.997C48.4384 121.124 48.1191 121.443 47.9924 121.851L47.8804 122.211C47.5612 123.238 46.2025 123.454 45.5813 122.575L45.3637 122.268C45.117 121.919 44.7145 121.714 44.2874 121.719L43.9107 121.724C42.835 121.738 42.2105 120.512 42.8539 119.65L43.0793 119.348C43.3348 119.006 43.4054 118.56 43.2682 118.155L43.1472 117.798C42.8018 116.779 43.7744 115.807 44.7933 116.152Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.590947
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.538 58.6795C112.728 57.6247 112.979 56.0535 114.093 55.1988C115.207 54.3441 116.789 54.5087 117.599 55.5635C117.6 55.5655 117.602 55.5675 117.603 55.5694",
    stroke: "white",
    strokeWidth: 20,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.590947
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.739 73.2283L121.095 73.3493C121.5 73.4865 121.946 73.4158 122.288 73.1603L122.59 72.935C123.453 72.2916 124.678 72.9161 124.664 73.9918L124.66 74.3685C124.654 74.7957 124.859 75.1982 125.208 75.4448L125.516 75.6624C126.394 76.2835 126.179 77.6421 125.152 77.9615L124.792 78.0733C124.384 78.2001 124.064 78.5196 123.938 78.9275L123.826 79.2873C123.506 80.3146 122.148 80.5297 121.527 79.6514L121.309 79.3438C121.062 78.9951 120.66 78.79 120.233 78.7955L119.856 78.8003C118.78 78.8139 118.156 77.5883 118.799 76.7262L119.025 76.4242C119.28 76.0818 119.351 75.6357 119.214 75.2311L119.092 74.8743C118.747 73.8555 119.72 72.8828 120.739 73.2283Z",
    fill: "#32D16D"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.590947
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.232 104.88C125.048 105.119 126.334 106.894 126.082 108.812C125.829 110.73 124.127 112.111 122.311 111.872C122.308 111.871 122.304 111.871 122.301 111.87",
    stroke: "#32D16D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.590947
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.511 127.41L115.925 128.326C115.637 128.491 115.27 128.393 115.105 128.106L112.241 123.145C112.075 122.858 112.173 122.491 112.46 122.325L114.046 121.41C114.334 121.244 114.701 121.342 114.866 121.629L117.73 126.59C117.896 126.877 117.798 127.244 117.511 127.41Z",
    fill: "#32D16D"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.590947
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.5295 130.303C64.4145 128.849 64.7597 126.685 66.2943 125.507C67.829 124.33 70.0093 124.556 71.1243 126.01L71.1307 126.018",
    stroke: "#32D16D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.725 85.9104C126.725 110.135 107.087 129.773 82.8627 129.773C58.6381 129.773 39 110.135 39 85.9104C39 61.6857 58.6381 42.0479 82.8627 42.0479C107.087 42.0479 126.725 61.6857 126.725 85.9104Z",
    fill: "#32D16D"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M113.418 85.9092C113.418 102.783 99.7392 116.462 82.8653 116.462C65.9915 116.462 52.3125 102.783 52.3125 85.9092C52.3125 69.0353 65.9915 55.3564 82.8653 55.3564C99.7392 55.3564 113.418 69.0353 113.418 85.9092Z",
    fill: "#32D16D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.375 85.962L78.3319 94.9189L96.3494 76.9013",
    stroke: "white",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportSuccess);
export default __webpack_public_path__ + "static/media/export_success.97c036126f339495a53abbbe85e436a5.svg";
export { ForwardRef as ReactComponent };